















































































import { Prop, Component, Vue } from "vue-property-decorator";
import { FolderEntry, Breadcrumb } from "@/models/file";
import IReportOutput from "@/api/models/IReportOutput";
import IReportSceneOutput from "@/api/models/IReportSceneOutput";
import createReportSceneOutput from "@/api/models/factories/createReportSceneOutput";

import VButtonMinus from "@/components/VButtonMinus.vue";
import VButtonPlusBlock from "@/components/VButtonPlusBlock.vue";
import VReportSceneControl from "@/components/VReportSceneControl.vue";
import VReportSelectModal from "@/components/VReportSelectModal.vue";
import formatDate from "@/helpers/formatDate";

import SwitchButton from "@/components/SwitchButton.vue";
import SelectOption from "@/common/ui/presenters/select-option";
import { Company, getAllCompanies } from "@/api/company-api";

@Component({
  components: {
    VButtonMinus,
    VButtonPlusBlock,
    VReportSceneControl,
    VReportSelectModal,
    SwitchButton
  }
})
export default class ReportEdit extends Vue {
  @Prop({ required: true }) report!: IReportOutput;
  @Prop({ required: true }) scenes!: IReportSceneOutput[];
  @Prop({ default: () => [] }) entries!: FolderEntry[];
  @Prop({ default: () => [] }) breadcrumbs!: Breadcrumb[];
  @Prop({ default: () => [] }) companies!: Company[];

  scene: IReportSceneOutput | null = null;

  status = "";
  check = "";
  companyId = "";

  get companyOptions(): SelectOption[] {
    return this.companies.map(c => ({
      text: c.name,
      value: c.companyId
    }));
  }

  private created() {
    this.companyId = this.scenes[0].companyId;
    this.initCompanies();
  }

  private async initCompanies() {
    this.companies = await getAllCompanies({ family: 1 });
  }

  ok() {
    if (this.report.startDate > this.report.endDate) {
      alert("施工期間の指定が不正です");
      this.check = "error";
    }

    const items = this.scenes;
    items.forEach(item => {
      if (!item.photoURL && item.photoURL === "") {
        alert("写真を選択していない欄があります");
        this.check = "error";
      }

      if (items.length < 1 && !item.companyId && item.companyId === "0") {
        alert("施工会社を選択していない欄があります");
        this.check = "error";
      }
    });
    if (this.check != "error") {
      items.forEach(item => {
        item.companyId = this.companyId;
      });
      this.status = "progressing";
      this.$emit("ok");
    } else {
      this.check = "";
    }
  }

  cd(id: string) {
    this.$emit("cd", id);
  }

  uploadPhoto(files: File[]) {
    this.$emit("uploadPhoto", files);
  }

  showReportModal() {
    this.cd("0");
    (this.$refs.reportModal as any).show();
  }

  areScenesEmpty() {
    return this.scenes.every(
      s =>
        !s.photoId &&
        !s.state &&
        !s.date &&
        !s.note &&
        !s.photoURL &&
        !s.companyId
    );
  }

  importPhotoList(entries: FolderEntry[]) {
    if (!entries.length) return;
    if (this.areScenesEmpty()) {
      this.scenes.splice(0, this.scenes.length);
    }
    entries.forEach(e => {
      const s = createReportSceneOutput();
      s.photoId = String(e.entryId);
      s.photoURL = e.image;
      this.scenes.push(s);
    });
  }

  showSceneModal(scene: IReportSceneOutput) {
    this.scene = scene;
    this.cd("0");
    (this.$refs.sceneModal as any).show();
  }

  changePhoto(entries: FolderEntry[]) {
    if (!this.scene) return;
    if (!entries.length) return;
    const photo = entries[0];
    this.scene.photoId = String(photo.entryId);
    this.scene.photoURL = String(photo.image);
    this.scene.date = formatDate(photo.updated);
    this.scene = null;
  }

  addScene() {
    this.scenes.push(createReportSceneOutput());
  }

  removeScene(i: number) {
    this.scenes.splice(i, 1);
  }

  swapScenes(i: number, j: number) {
    const a = this.scenes[i];
    const b = this.scenes[j];
    if (a && b) {
      this.$set(this.scenes, i, b);
      this.$set(this.scenes, j, a);
    }
    console.info("swap", this.scenes);
  }
}
